<template>
  <v-card outlined class="mb-2">
    <v-card-title>
      Run #{{ run.id }}
      <v-spacer />
      <v-chip small :color="statusColor">{{ run.status }}</v-chip>
    </v-card-title>
    <v-card-subtitle>
      {{ formatDate(run.period_start) }} → {{ formatDate(run.period_end) }}
      &nbsp;·&nbsp; {{ run.subject_count }} subjects
      &nbsp;·&nbsp; created by {{ run.created_by_name || '—' }}
      &nbsp;·&nbsp; target {{ run.target_per_stratum }} / floor {{ run.floor_per_stratum }}
    </v-card-subtitle>
    <v-card-actions>
      <v-btn small text color="primary" :to="`/verification/runs/${run.id}`">
        Open
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'SampleRunCard',
  props: {
    run: { type: Object, required: true },
  },
  computed: {
    statusColor () {
      switch (this.run.status) {
        case 'open': return 'primary'
        case 'completed': return 'success'
        case 'cancelled': return 'grey'
        default: return 'default'
      }
    },
  },
  methods: {
    formatDate (iso) {
      if (!iso) return ''
      return new Date(iso).toISOString().slice(0, 10)
    },
  },
}
</script>
